import React from "react";
import {
  FaCrown,
  FaUserCheck,
  FaUserShield,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";

function StatCard({ icon: Icon, label, value, description, tone = "blue" }) {
  const styles = {
    blue: "bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200",
    indigo:
      "bg-indigo-100 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-200",
    amber:
      "bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200",
    red: "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-200",
    green:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200",
  };

  return (
    <article className="rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex items-start gap-3">
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${
            styles[tone] || styles.blue
          }`}
        >
          <Icon />
        </div>

        <div>
          <p className="font-titre text-3xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            {label}
          </p>
          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </article>
  );
}

function UserStats({ stats }) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
      <StatCard
        icon={FaUsers}
        label="Total"
        value={stats.total}
        description="Comptes créés"
        tone="blue"
      />

      <StatCard
        icon={FaUserShield}
        label="Admins"
        value={stats.admins}
        description="Accès complet"
        tone="red"
      />

      <StatCard
        icon={FaUserTie}
        label="Coachs"
        value={stats.coachs + stats.coachPro + stats.coachUltim}
        description="Coach, Pro, Ultim"
        tone="amber"
      />

      <StatCard
        icon={FaCrown}
        label="Abonnés Ultim"
        value={stats.coachUltim}
        description="Formule maximale"
        tone="indigo"
      />

      <StatCard
        icon={FaUserCheck}
        label="Avec judoka"
        value={stats.withAdherent}
        description="Compte rattaché"
        tone="green"
      />
    </section>
  );
}

export default UserStats;